// Angular
import { Injector, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
// Model
import { environment } from '../lib/environments/environment';
// Component
import { LoginComponent } from './auth/components/login/login.component';
import { HeaderComponent } from './layout/header/header.component';
import { FooterComponent } from './layout/footer/footer.component';
import { BreadcrumbComponent } from './layout/breadcrumb/breadcrumb.component';
import { SubContentComponent } from './layout/sub-content/sub-content.component';
import { ToasterComponent } from './layout/toaster/toaster.component';
import { CustomDateCellComponent } from './layout/custom-grid-cells/custom-date-cell/custom-date-cell.component';
import { CustomPersonCellComponent } from './layout/custom-grid-cells/custom-person-cell/custom-person-cell.component';
import { ContentLoaderComponent } from './layout/content-loader/content-loader.component';
import { DynamicContentDirective } from './layout/dynamic-component/dynamic-content.directive';
import { ReleaseNotesComponent } from './layout/release-notes/release-notes.component';
import { DynamicHostComponent } from './layout/modal/dynamic-host/dynamic-host.component';
import { CustomActiveCellComponent } from './layout/custom-grid-cells/custom-active-cell/custom-active-cell.component';
import {
	OrderEventNotificationComponent
} from './layout/header/components/event-inbox/order-event-notification.component';
import { AuthenticateComponent } from './auth/components/authenticate/authenticate.component';
import { ModalComponent } from './layout/modal/components/modal.component';
import { ModalConfirmComponent } from './layout/modal/components/modal-confirm/modal-confirm.component';
import { SystemInfoComponent } from './system-info/system-info.component';
import { VersionLabelComponent } from './system-info/version-label/version-label.component';
import { ChangeStateComponent } from './system-info/change-state/change-state.component';
import { DownloadLinkComponent } from './layout/download-link/download-link.component';
import { SelectListCellRenderer } from './layout/grid-base-component/renderer/select-list-cell.renderer';
import { TextBoxCellRenderer } from './layout/grid-base-component/renderer/text-box-cell.renderer';
import { SuffixCellRenderer } from './layout/grid-base-component/renderer/suffix-cell.renderer';
import { PWAHeaderComponent } from './layout/header/components/pwa-header/pwa-header.component';
import { InvisionHeaderComponent } from './layout/header/components/invision-header/invision-header.component';
import { UserInfoHeaderComponent } from './layout/header/components/user-info/user-info-header.component';
import { RealTimeStatusComponent } from './layout/header/components/real-time/real-time-status.component';
import { DMLicenseDialogComponent } from './layout/header/components/dm-license-dialog/dm-license-dialog.component';
// Store
import { NgxsModule } from '@ngxs/store';
import { NgxsReduxDevtoolsPluginModule } from '@ngxs/devtools-plugin';
// import {NgxsLoggerPluginModule} from '@ngxs/logger-plugin';
import { NgxsStoragePluginModule } from '@ngxs/storage-plugin';
import { AppState } from './state/app.state';
import { UserContextState } from './auth/user-context.state';
import { SignalRState } from './signal-r/signal-r.state';
import { UIConfigState } from './ui-config/ui-config.state';
// Services
import { DynamicHostDirective } from './layout/modal/dynamic-host/dynamic-host.directive';
import { CookiesConfigService } from './service/cookies-config.service';
// Modules
import { CvComponentLibraryModule } from '@cv-invision/cv.component-library.ux';
import { HttpCoreModule } from './http-core.module';
import { ClearStatePluginModule } from './meta-reducer/clear-state.module';
import { ErrorTrackState } from './error-track/error-track.state';
import {ButtonModule} from 'primeng/button';

@NgModule({
	imports: [
		CommonModule,
		FormsModule,
		RouterModule,
		ReactiveFormsModule,
		NgxsModule.forRoot([
			AppState,
			UIConfigState,
			UserContextState,
			SignalRState,
			ErrorTrackState
		], {
			developmentMode: !environment.production
		}),
		NgxsReduxDevtoolsPluginModule.forRoot(),
		// NgxsLoggerPluginModule.forRoot({disabled: environment.production}),
		NgxsStoragePluginModule.forRoot({
			key: ['user.token']
		}),
		ClearStatePluginModule.forRoot({}),
		HttpCoreModule,
		CvComponentLibraryModule,
		ButtonModule
	],
	providers: [CookiesConfigService ],
	exports: [
		HeaderComponent,
		FooterComponent,
		BreadcrumbComponent,
		SubContentComponent,
		ToasterComponent,
		ContentLoaderComponent,
		ReleaseNotesComponent,
		DownloadLinkComponent,
		ModalComponent,
		ModalConfirmComponent,
		DynamicHostComponent,
		// Directive
		DynamicContentDirective,
		DynamicHostDirective,
		// Custom Cells for AG-GRID
		CustomDateCellComponent,
		CustomPersonCellComponent,
		CustomActiveCellComponent
	],
	declarations: [
		// System Info
		VersionLabelComponent,
		SystemInfoComponent,
		ChangeStateComponent,
		// --
		LoginComponent,
		HeaderComponent,
		OrderEventNotificationComponent,
		FooterComponent,
		BreadcrumbComponent,
		SubContentComponent,
		ToasterComponent,
		ContentLoaderComponent,
		ReleaseNotesComponent,
		DownloadLinkComponent,
		ModalComponent,
		ModalConfirmComponent,
		DynamicHostComponent,
		InvisionHeaderComponent,
		PWAHeaderComponent,
		UserInfoHeaderComponent,
		DMLicenseDialogComponent,
		RealTimeStatusComponent,
		// Directive
		DynamicContentDirective,
		AuthenticateComponent,
		DynamicHostDirective,
		// Custom Cells for AG-GRID
		CustomDateCellComponent,
		CustomPersonCellComponent,
		CustomActiveCellComponent,
		SelectListCellRenderer,
		TextBoxCellRenderer,
		SuffixCellRenderer
	],
	entryComponents: [
		ModalConfirmComponent,
		// Custom Cells for AG-GRID
		CustomDateCellComponent,
		CustomPersonCellComponent,
		CustomActiveCellComponent,
		SelectListCellRenderer,
		TextBoxCellRenderer,
		SuffixCellRenderer
	]
})
export class CoreModule {
	static injector: Injector;

	constructor(injector: Injector) {
		CoreModule.injector = injector;
	}
}
